import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartDonutFilled = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5A.75.75 0 0 0 8 3a5 5 0 1 1-5 5 .75.75 0 0 0-1.5 0A6.5 6.5 0 1 0 8 1.5zm0 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z" />
    </g>
  );
};

export default withIcon(IconChartDonutFilled);
